// @ts-nocheck

'use client'

import React, { useState } from "react";

import * as S from "./Login.styles";

import { AuthenticationFormError } from '../AuthenticationHandler.styles'

import { SpacerBase, Container, Row, Col } from '../../../atoms/GridSystem';
import { Paragraph, Heading } from "../../../atoms/Typography/Typography.component";
import Button from "../../../atoms/Button/Button.component";
import Icon from "../../../atoms/Icon/Icon.component";
import Input from "../../../atoms/Fields/Input/Input.component";
import ModalAuth from "../../Modal/ModalAuth/ModalAuth.component";
import { useModal } from "../../../../contexts/Modal.context";
import { useUserMeta } from "../../../../contexts/UserMeta.context";
import { getPageLocale } from "@caffeina-siad/utils";

import { Formik, Form } from "formik";
import * as Yup from 'yup'

import Image from 'next/image';
import { useRouter } from "next/navigation";
import { useTranslations } from 'next-intl';

const Login = ({ webAuthClient, setTemplate, authorize }: { webAuthClient: auth0.WebAuth | null, setTemplate: (template: string) => void, authorize: (authToken: string) => Promise<any> }): JSX.Element => {
  const router = useRouter();
  const [ formError, setFormError ] = useState(false);
  const { showModal } = useModal()
  const { handleSetUserMeta } = useUserMeta()
  const t = useTranslations();

  const handleAuth0Errors = (err) => {
    const { code } = err;

    if (code === 'invalid_grant') {
      setFormError(t('login.loginFormError'));
    }
  }

  const handleLogin = ({ email, password }) => {
    if (!webAuthClient) return;
    setFormError(false);

    webAuthClient.client.login(
      {
        realm: 'Username-Password-Authentication', //connection name or HRD domain
        username: email,
        password,
        scope: 'openid profile email read:current_user update:current_user_metadata'
      },
      function (err, authResult) {
        if (err) {
          handleAuth0Errors(err);
          return;
        }

        authorize(authResult.accessToken).then((res) => {
          // if (!res.auth0.email_verified) {
          if (false) {
            showModal(ModalAuth, {
              title: t('login.loginModalTitle'),
              description: t('login.loginModalEmailNotVerified'),
              cta: {
                label: t('login.loginModalCta'),
                handleClick: () => {
                  webAuthClient.logout({
                    returnTo: `${process.env.NEXT_PUBLIC_SITE_URL}/${getPageLocale()}`
                  });
                }
              },
              foreground: true
            })

            return

          } else if (!res.data.approved) {
            showModal(ModalAuth, {
              title: t('login.loginModalTitle'),
              description: t('login.loginModalDescription'),
              cta: {
                label: t('login.loginModalCta'),
                handleClick: () => {
                  webAuthClient.logout({
                    returnTo: `${process.env.NEXT_PUBLIC_SITE_URL}/${getPageLocale()}`
                  });
                }
              },
              foreground: true
            })
        
            return
            
          } else {
            const localizedPrivateAreaSlug = getPageLocale() === 'it' ? 'area-privata' : 'private-area'
  
            setTimeout(() => {
              router.push(`${process.env.NEXT_PUBLIC_SITE_URL}/${getPageLocale()}/${localizedPrivateAreaSlug}?accessToken=${authResult.accessToken}`)
            }, 1000)
          }

        }).catch((err) => {
          console.error(err)
        })
      }
    );
  }

  return (
    <S.Login>
      <Container>
        <Row>
          <Col xs={12} lg={6}>
            <Formik
              initialValues={{
                email: '',
                password: ''
              }}
              validationSchema={Yup.object({
                email: Yup.string().email(t('login.loginFormEmailError')).required(t('global.formErrorRequired')),
                password: Yup.string().required(t('global.formErrorRequired'))
              })}
              onSubmit={(values) => handleLogin(values)}
            >
              {({ values, errors, touched, handleChange, handleSubmit }) => {

                return (
                  <Form>
                    <S.LoginForm>
                      <S.LoginFormIcon>
                        <Icon name={'brand-logo'} useIconColor unlockedProportions />
                      </S.LoginFormIcon>
                      <SpacerBase xs={2} />
                      <Heading
                        content={t('login.title')}
                        typo={'headingLG'}
                      />
                      <SpacerBase xs={2} />
                      <S.LoginFormRegister>
                        <Paragraph 
                          content={t('login.subtitle')}
                          typo={'buttonMD'}
                        />
                        <S.LoginFormRegisterCTA
                          onClick={() => setTemplate('register')}
                        >
                          <Paragraph 
                            content={t('login.register')}
                            typo={'buttonMD'}
                          />
                        </S.LoginFormRegisterCTA>
                      </S.LoginFormRegister>
                      <SpacerBase xs={3} />
                      <S.LoginFormInputWrapper>
                        <Input type="text" placeholder={t('login.loginFormEmailPlaceholder')} name="email"  />
                      </S.LoginFormInputWrapper>
                      <SpacerBase xs={4} />
                      <S.LoginFormInputWrapper>
                        <Input type="password" placeholder={t('login.loginFormPasswordPlaceholder')} name="password" />
                      </S.LoginFormInputWrapper>
                      <SpacerBase xs={4} />
                      {formError ? (
                        <>
                          <AuthenticationFormError>
                            <Paragraph 
                              content={formError}
                              typo={'paragraphSM'}
                            />
                          </AuthenticationFormError>
                          <SpacerBase xs={2} />
                        </>
                      ) : null}
                      <Button 
                        label={t('login.loginCta')} 
                        variant="primary" 
                        iconEnd="arrow-right"
                        fullWidth
                        type={'submit'}
                      />
                      <SpacerBase xs={2} />
                      <S.LoginFormResetPassword>
                        <S.LoginFormRegisterCTA
                          onClick={() => setTemplate('reset-password')}
                        >
                          <Paragraph 
                            content={t('login.resetPassword')}
                            typo={'buttonMD'}
                          />
                        </S.LoginFormRegisterCTA>
                      </S.LoginFormResetPassword>
                    </S.LoginForm>
                  </Form>
                )
              }}
            </Formik>
          </Col>
        </Row>
      </Container>
      <S.LoginImageWrapper>
        <Image
          src="/images/concorso.jpg"
          alt="Login Background"
          fill
        />
      </S.LoginImageWrapper>
    </S.Login>
  );
}

export default Login;
